import { render, staticRenderFns } from "./thumbnail-navigation.vue?vue&type=template&id=7b9c6992&scoped=true&lang=pug&"
import script from "./thumbnail-navigation.vue?vue&type=script&lang=coffee&"
export * from "./thumbnail-navigation.vue?vue&type=script&lang=coffee&"
import style0 from "./thumbnail-navigation.vue?vue&type=style&index=0&id=7b9c6992&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9c6992",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdpThumbnailImage: require('/opt/build/repo/nuxt-app/components/pages/pdp/thumbnail-image.vue').default})
